import { Invoice } from './Invoice';

export class InvoiceDetails {

    private invoices: Invoice[];
    private totalInvoiceAmount: number;
    private totalNonClaimableAmount: number;
    private totalClaimableAmount: number;
    private totalApprovedAmount: number;
    private invoiceSummaries: any[];
   


    constructor(invoiceDetailsDto: any) {
        this.totalClaimableAmount = invoiceDetailsDto.totalClaimableAmount;
        this.totalNonClaimableAmount = invoiceDetailsDto.totalNonClaimableAmount;
        this.totalInvoiceAmount = invoiceDetailsDto.totalInvoiceAmount;
        this.totalApprovedAmount = invoiceDetailsDto.totalApprovedAmount;

        if (invoiceDetailsDto.invoiceSummaries) {
            this.invoiceSummaries = [];
            for ( const invoice of invoiceDetailsDto.invoiceSummaries) {
                this.invoiceSummaries.push(invoice);
            }
        }

        if (invoiceDetailsDto.invoices) {
            this.invoices = [];
            for ( const invoice of invoiceDetailsDto.invoices) {
                this.invoices.push(new Invoice(invoice));
            }
        }
    }

    public get $invoiceSummaries(): any[] {
        return this.invoiceSummaries;
    }
    public set $invoiceSummaries(value: any[]) {
        this.invoiceSummaries = value;
    }

    public get $totalApprovedAmount(): number {
        return this.totalApprovedAmount;
    }
    public set $totalApprovedAmount(value: number) {
        this.totalApprovedAmount = value;
    }
    /**
     * Getter $invoices
     * @return {Invoice[]}
     */
	public get $invoices(): Invoice[] {
		return this.invoices;
	}

    /**
     * Getter $totalInvoiceAmount
     * @return {number}
     */
	public get $totalInvoiceAmount(): number {
		return this.totalInvoiceAmount;
	}

    /**
     * Getter $totalNonClaimableAmount
     * @return {number}
     */
	public get $totalNonClaimableAmount(): number {
		return this.totalNonClaimableAmount;
	}

    /**
     * Getter $totalClaimableAmount
     * @return {number}
     */
	public get $totalClaimableAmount(): number {
		return this.totalClaimableAmount;
	}

    /**
     * Setter $invoices
     * @param {Invoice[]} value
     */
	public set $invoices(value: Invoice[]) {
		this.invoices = value;
	}

    /**
     * Setter $totalInvoiceAmount
     * @param {number} value
     */
	public set $totalInvoiceAmount(value: number) {
		this.totalInvoiceAmount = value;
	}

    /**
     * Setter $totalNonClaimableAmount
     * @param {number} value
     */
	public set $totalNonClaimableAmount(value: number) {
		this.totalNonClaimableAmount = value;
	}

    /**
     * Setter $totalClaimableAmount
     * @param {number} value
     */
	public set $totalClaimableAmount(value: number) {
		this.totalClaimableAmount = value;
	}
   
}
